/* unplugin-vue-components disabled */import { render } from "./BlankLayout.vue?vue&type=template&id=32c7f030"
const script = {}

import exportComponent from "/Users/zouchanghua/Documents/project/xrverse/xrweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__